// Keep the reviewed request independent from later edits to the draft.
export function handoverChoices(items,choices,keys,action){
 const selected=new Set(keys);
 if(!selected.size||keys.some(key=>!items.some(i=>i.key===key&&i.actions.includes(action))))throw Error('invalid_handover_choices');
 return {...choices,...Object.fromEntries(items.filter(i=>selected.has(i.key)).map(i=>[i.key,action]))};
}
export function handoverReview(plan,{target,reason,choices,fleetId=''}){
 if(!plan?.version||!target||!reason.trim()||Object.keys(choices).length!==plan.items.length||plan.items.some(i=>!i.actions.includes(choices[i.key])))throw Error('invalid_handover_choices');
 return {email:target,version:plan.version,reason:reason.trim(),choices:{...choices},fleetId};
}
